import { Box, Grid, Stack, styled, Typography } from "@mui/material";
import React from "react";

const StyledWrapperStack = styled(Stack)(({ theme }) => ({
  background: theme.palette.background.default,
  padding: "20px",
  zIndex: 99,
  [theme.breakpoints.down("sm")]: {
    paddingTop: "20px",
  },
}));

const StyledItemStack = styled(Stack)(({ theme }) => ({
  background: theme.palette.background.main,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "10px",
  padding: "15px 60px",
  gap: "15px",
  height: "100%",
  boxSizing: "border-box",
  [theme.breakpoints.down("sm")]: {
    padding: "15px 37.5px",
  },
}));
const ConvenientBar = () => {
  return (
    <StyledWrapperStack>
      <Grid container spacing={2} justifyContent="center">
        {data.map((item, index) => (
          <Grid item key={index} xs={12} md={3}>
            <StyledItemStack direction="column" alignItems="start"> 
              <Stack
                direction={"row"}
                alignItems="center"
                gap={2}
                >
              <Box
                component="img"
                src={item.icon}
                width={{ xs: "40px", md: "60px" }}
                height={{ xs: "40px", md: "60px" }}
              />            
              <Typography
                variant="h5"
                color="text.secondary"
                align="start"
              >
                {item.txt1}
              </Typography>
              </Stack>
              <Typography
                variant="h6"
                color="text.secondary"
                align="start"
                fontWeight={400}
              >
                {item.txt2}
              </Typography>
            </StyledItemStack>
          </Grid>
        ))}
      </Grid>
    </StyledWrapperStack>
  );
};

export default ConvenientBar;

const data = [
  {
    icon: "/assets/home/IconContainer1.svg",
    txt2: "Desde inicio de la idea se efectúa con el absoluto enfoque de nuestros inversionistas y mercado meta",
    txt1: "Planeación Estratégica",
  },
  {
    icon: "/assets/home/IconContainer.svg",
    txt2: "Los más destacados especialistas nos proyectan a un mundo nuevo de creaciones únicas",
    txt1: "Diseño de Concepto",
  },
  {
    icon: "/assets/home/IconContainer3.svg",
    txt2: "Equipos de renombre y experiencia culminan la ardua tarea de concebir nuestras mas alocadas ideas!",
    txt1: "Desarrollo Integral",
  },
  
];